import { combineReducers } from 'redux';
import getApiReducer from '../../../common/utils/getApiReducer';
import {
  GET_COURSE,
  GET_QUIZ,
  SUBMIT_QUIZ,
  GET_COURSES,
  GET_FEATURED_COURSE,
  GET_COURSE_PREVIEW,
  GET_LESSON_VIDEO,
  COMPLETE_LESSON,
  COMPLETE_CHAPTER,
  COMPLETE_COURSE,
  ENROLL_COURSE,
} from './actions';
import { VIDEO_PROGRESS, COMPLETE_VIDEO } from '../../redux/actions';

const coursesReducer = getApiReducer(GET_COURSES);
const courses = (state, action) => {
  const nextState = coursesReducer(state, action);

  if (action.type === `${COMPLETE_COURSE}_REQUEST`) {
    const courseIndex = nextState.get('data').findIndex(course => {
      return course.get('id') === action.courseId;
    });

    return nextState.setIn(['data', courseIndex, 'complete'], true);
  }

  return nextState;
};

const featuredCourse = getApiReducer(GET_FEATURED_COURSE);

const courseReducer = getApiReducer(GET_COURSE);
const course = (state, action) => {
  const nextState = courseReducer(state, action);

  switch (action.type) {
    case `${COMPLETE_LESSON}_REQUEST`:
      return nextState.setIn(
        ['data', 'lessons'],
        nextState.getIn(['data', 'lessons']).map(lesson => {
          const complete = lesson.get('complete') || lesson.get('id').toString() === action.lessonId.toString();
          return lesson.set('complete', complete);
        })
      );
    case `${COMPLETE_CHAPTER}_REQUEST`:
      return nextState.setIn(
        ['data', 'chapters'],
        nextState.getIn(['data', 'chapters']).map(chapter => {
          const complete = chapter.get('complete') || chapter.get('id').toString() === action.chapterId.toString();
          return chapter.set('complete', complete);
        })
      );
    case `${ENROLL_COURSE}_SUCCESS`:
      return nextState.setIn(['data', 'enrolled'], true);
    case `${COMPLETE_COURSE}_REQUEST`:
      return nextState.setIn(['data', 'complete'], true);
    default:
      return nextState;
  }
};

const quizReducer = getApiReducer(GET_QUIZ);
const quiz = (state, action) => {
  let nextState = quizReducer(state, action);

  if (action.type === `${SUBMIT_QUIZ}_SUCCESS`) {
    return nextState.setIn(['data', 'passed'], action.json.passed);
  }

  return nextState;
};

const quizResults = getApiReducer(SUBMIT_QUIZ);

const coursePreview = getApiReducer(GET_COURSE_PREVIEW);

const lessonVideoReducer = getApiReducer(GET_LESSON_VIDEO);
const lessonVideo = (state, action) => {
  let nextState = lessonVideoReducer(state, action);

  if (action.type === `${VIDEO_PROGRESS}_SUCCESS` && action.videoId === nextState.getIn(['data', 'id'])) {
    return nextState.setIn(['data', 'progress'], action.progress);
  }

  if (action.type === `${COMPLETE_VIDEO}_SUCCESS` && action.videoId === nextState.getIn(['data', 'id'])) {
    return nextState.setIn(['data', 'complete'], true);
  }

  return nextState;
};

const enrollCourse = getApiReducer(ENROLL_COURSE);

export default combineReducers({
  coursePreview,
  courses,
  course,
  enrollCourse,
  featuredCourse,
  lessonVideo,
  quiz,
  quizResults,
});



// WEBPACK FOOTER //
// ./src/subscription/courses/redux/reducers.js